import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideDotCore } from '@dot/core';
import { authCodeFlowConfig, environment } from '../environments/environment';
import { APP_ROOT } from './injectionTokens/app-root';
import { provideDokaI18Next } from '@doka/i18next';
import { defaultLocale, defaultTranslation, loadBundledLocale, loadBundledTranslation } from './locals/i18n-imports';
import { authInterceptor, DokaIdentityLoginService, provideDokaLogin } from '@doka/identity-login';
import { provideApi } from '@dot/yard-api-client';
import { provideAngularCore } from '@doka/angular-core';

export const appConfig: ApplicationConfig = {
  providers: [
    // provides the API URL for the Yard API client
    provideApi(environment.yardApiUrl),
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: OAuthStorage, useValue: localStorage },
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideIonicAngular(),
    provideAnimations(),
    provideOAuthClient(),
    //provides DOT Libraries use dedicated provider Functions if you do not need @dot/core
    provideDotCore({
      // Configuration for @dot/authorization
      authorizerConfig: {
        appName: 'Template',
        defaultToSelectedBranchId: true,
        routes: routes,
      },
      // Configuration for @dot/config
      configConfig: {
        appId: environment.appId,
      },
      // Configuration for @dot/core
      dotCoreConfig: {
        appIcon: 'assets/icon.png',
      },
    }),
    provideDokaLogin(() => {
      const app_root = inject(APP_ROOT);
      return {
        authCodeFlowConfig: authCodeFlowConfig,
        rootUrl: '/' + app_root,
        useServiceWorker: true,
        whiteList: [],
      };
    }),
    provideAngularCore(() => {
      const identityLoginService = inject(DokaIdentityLoginService);
      return {
        angularCoreConfig: {
          applyCustomStyles: true,
          awaitHandleTranslations: true,
        },
        notificationConfig: {
          tokenUrl: `${environment.yardApiUrl}/api/notifications/inbox/token`,
          accessTokenSignal: identityLoginService.accessToken$,
        },
      };
    }),
    provideDokaI18Next(() => {
      const identityLoginService = inject(DokaIdentityLoginService);
      return {
        resources: defaultTranslation,
        locales: defaultLocale,
        clientId: authCodeFlowConfig.clientId,
        idsUrl: authCodeFlowConfig.issuer,
        isLoggedIn$: identityLoginService.isLoggedIn$,
        localeLoader: loadBundledLocale,
        translationLoader: loadBundledTranslation,
        translationsUrl: environment.yardApiUrl,
        useHttpBackend: true,
      };
    }),
    provideRouter(routes),
    //adds HTTP authorization header to non whitelisted requests using @doka-shared/identity-login
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
  ],
};
